import getApi from '@/lib/axios';
import { Card } from 'primereact/card';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ColumnModel } from '@/features/crm/types';
import { TypesCRM } from '@/types/crm.ts';

async function changeStepCard(id: number, stepId: number) {
  const api = await getApi();

  return api.patch<Card>(`/crm/cartoes/${id}/`, {
    step: stepId,
  });
}

export { changeStepCard };


type mutationFnProps = {
  id: number;
  stepId: number;
  type: TypesCRM;
  sourceColumnId?: number; // Coluna de origem
};

export const useUpdateStepCard = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, stepId, type }: mutationFnProps) => changeStepCard(id, stepId),
    
    // Atualização otimista - atualiza UI antes da resposta do servidor
    onMutate: async (variables) => {
      // Cancela queries em andamento para evitar conflitos
      await queryClient.cancelQueries({ queryKey: ['step-column-cards'] });

      // Salva o estado anterior para rollback em caso de erro
      const previousData = queryClient.getQueriesData({ queryKey: ['step-column-cards'] });

      return { previousData };
    },

    onSuccess: async (result, variables) => {
      // Invalida as queries de cards das colunas afetadas
      // Isso força o React Query a recarregar os dados das colunas
      queryClient.invalidateQueries({
        queryKey: ['step-column-cards'],
        refetchType: 'active'
      });

      // Também invalida a lista de colunas caso necessário
      queryClient.invalidateQueries({
        queryKey: ['fetch-columns', variables.type],
      });
    },

    // Em caso de erro, restaura o estado anterior
    onError: (err, variables, context) => {
      if (context?.previousData) {
        context.previousData.forEach(([queryKey, data]) => {
          queryClient.setQueryData(queryKey, data);
        });
      }
    },
  });
};